module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_foodfly.7e3ec15f37ae14df2d8a391dd2553a78.png";